import React, {Component} from 'react'
import { Waypoint } from 'react-waypoint'

import Player from '../Player/Player';
import Lock from '../Lock/Lock'

import './styles.scss'


class ChapterThree extends Component {
    constructor(props) {
        super(props);
        this.state = { width: 0, height: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
        
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
        
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    render () {
        return (
            <>
                <Waypoint horizontal onEnter={()=>{this.props.chapterTransition("three")}}> 
                    <div className="chapter chapter-three chapter-3" style={{height: this.state.height + "px" }}>
                        <div className="scroll-container montain">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container bg">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container bg-solid">
                            <div className="scroll"></div>
                        </div>
                        
                        <div className="scroll-container one">
                            <div className="green-content scroll">
                                <p>Visste du at noen trær kan bli over</p>
                                <div className="statement">1000 år?</div>
                            </div>
                            <Player file="3_1" />
                        </div>
                        <div className="scroll-container two">
                            <div className="white-content scroll">
                                <p>Det betyr at de kan ha opplevd <b>vikingtida</b>, det!</p>
                            </div>
                            <Player file="3_2" />
                        </div>
                        <div className="scroll-container three">
                            <div className="green-content scroll">
                                <p>Du kan ikke se på størrelsen av treet om det er ungt eller gammelt. Korte trær kan ha opplevd vikinghjelmer og langskip, mens lange trær bare har sett GoPro-kameraer og sparkesykler.</p>
                            </div>
                            <Player file="3_3" />
                        </div>
                        <div className="scroll-container four">
                            <div className="white-content scroll">
                                <h2>Størrelsen kommer helt an på hvordan treet har hatt det i oppveksten.</h2>
                                <p>Har treet tilgang på både sol, varme og næring kan det skyte i været på relativt kort tid. Står treet i skyggen av andre trær må det konkurrere med de andre om tingene det trenger. Det gjør at treet vokser tregere.</p>
                            </div>
                            <Player file="3_4" />
                        </div>
                        <div className="scroll-container five">
                            <div className="green-content scroll">
                                <p>Skal du finne ut hvor gammelt et tre er, må du <b>telle årringer</b> på stubben. Treet lager en ny ring hvert år. Den består av en lys del (vårved) og en mørk del (sommerved).</p>
                            </div>
                            <Player file="3_5" />
                        </div>
                        <div className="scroll-container six">
                            <div className="white-content scroll">
                                <h2>Trærne har ulike personligheter.</h2>
                                <p><b>Osp</b>​ liker seg best alene og har runde blader som skjelver i vinden, nesten som det er nervøst.</p>
                                <p><b>Furu</b>​ kan både vokse der det er veldig vått og veldig tørt. Hvis furua får nok næring kan den bli opptil 40 meter høy!</p>
                                <p>​<b>Gran</b> kan bli enda høyere enn furu, opptil 50 meter høyt, men har kortere nåler enn furua. Mange av dem som feirer jul, forbinder lukten av gran med jul. Det er fordi gran brukes som juletre.</p>
                                <p><b>Bjørk</b>​ har hvit stamme, og ​<b>lønn</b>​ får blader med fine farger på høsten.</p>
                            </div>
                            <Player file="3_6" />
                        </div>
                        <div className="scroll-container seven">
                            <div className="green-content scroll">
                                <h2>Eika har grov stamme, bølgete blader og nøtter på høsten.</h2>
                                <p>Det blir stadig færre eiker, og derfor har mange andre arter også blitt utrydningstruet. Inne i skikkelig gamle, hule eiker kan det bo like mange insekter, sopper og lav som det bor mennesker i Oslo. Snakk om trehus!</p>
                            </div>
                            <Player file="3_7" />
                        </div>
                        <div className="scroll-container vikings">
                            <div className="scroll ">
                            </div>
                        </div>
                        <div className="scroll-container lumber">
                            <div className="scroll "> 
                            </div>
                        </div>
                        <div className="scroll-container three-20">
                            <div className="scroll"></div>
                        </div>
                        <div className="scroll-container three-450">
                            <div className="scroll"></div>
                        </div>
                        <div className="thank-you">Takk for at du skyller, bretter og stapper skolemelka for trærne!</div>
                        <Lock 
                            progress="four"
                            handleModal={this.props.handleModal}
                            >
                        </Lock>
                    </div>
                </Waypoint>
            </>
        )
    }
}

export default ChapterThree
